<template>
    <div id="PunchInClock">

		<v-divider></v-divider>
        <div class="clock">
            <div class="hour"></div>
            <div class="min"></div>
            <div class="sec"></div>
        </div>

		<div class="mt-8">
			<h1 class="display-1" :style="$vuetify.breakpoint.xsOnly ? 'font-size: 25px !important' : 'font-weight: 400'">{{todayStr()}}</h1>
		</div>
        <div class="d-flex my-8">
            <v-card style="font-weight: 300;" elevation="0" class="digitalHour display-3 pa-4">
            </v-card>
            <span class="display-3 align-self-center mx-2 grey--text">:</span>
            <v-card style="font-weight: 300;" elevation="0" class="digitalMinute display-3 pa-4">
            </v-card>
            <span class="display-3 align-self-center mx-2 grey--text">:</span>
            <v-card style="font-weight: 300;" elevation="0" class="digitalSecond display-3 pa-4">
            </v-card>
        </div>

        <div>
            <v-btn @click="savePunchNow()" :width="$vuetify.breakpoint.xsOnly ? 300 : 400" color="success" depressed>Fichar</v-btn>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex';
import {todayStr} from '@/util/libUtil.js';

export default {
	name: "PunchInClock",
	data: () => ({

	}),
	methods: {
		todayStr,
		...mapActions('punchIn', ['savePunchNow']),
	},
	computed: {
		userHasChecked(){
			return true
		}
	},
	mounted(){

		const deg = 6;
		const hour = document.querySelector(".hour");
		const min = document.querySelector(".min");
		const sec = document.querySelector(".sec");

		const digitalHour = document.querySelector(".digitalHour");
		const digitalMinute = document.querySelector(".digitalMinute");
		const digitalSecond = document.querySelector(".digitalSecond");

		const setClock = () => {
			let day = new Date();
			let hh = day.getHours();
			let mm = day.getMinutes();
			let ss = day.getSeconds();

			digitalHour.innerHTML = String(hh).length < 2 ? `0${hh}` : hh;
			digitalMinute.innerHTML = String(mm).length < 2 ? `0${mm}` : mm;
			digitalSecond.innerHTML = String(ss).length < 2 ? `0${ss}` : ss;

			hour.style.transform = `rotateZ(${hh * 30 + mm *deg / 12}deg)`;
			min.style.transform = `rotateZ(${mm * deg}deg)`;
			sec.style.transform = `rotateZ(${ss * deg}deg)`;
		};

		// first time
		setClock();
		// Update every 1000 ms
		setInterval(setClock, 1000);
	},

}
</script>

<style scoped>
    :root {
	--main-bg-color: #fff;
	--main-text-color: #888888;
}

* {
	box-sizing: border-box;
	/* 		transition: all ease 0.2s; */
}

#PunchInClock {
	margin: 0;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	font-size: 16px;
	transition: all ease 0.2s;
	padding-bottom: 0px;
}

.clock {
	min-height: 26em;
	min-width: 26em;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #fff;
	background-image: url("../../../public/clock.png");
	image-rendering: auto;
	background-position: center center;
	background-size: cover;
	border-radius: 50%;
	border: 4px solid #fff;
	box-shadow: 0 -15px 15px rgba(255, 255, 255, 0.05),
		inset 0 -15px 15px rgba(255, 255, 255, 0.05), 0 15px 15px rgba(0, 0, 0, 0.3),
		inset 0 15px 15px rgba(0, 0, 0, 0.3);
	transition: all ease 0.2s;
}
.clock:before {
	content: "";
	height: 0.75rem;
	width: 0.75rem;
	background-color: #888888;
	border: 2px solid #fff;
	position: absolute;
	border-radius: 50%;
	z-index: 1;
	transition: all ease 0.2s;
}
.hour,
.min,
.sec {
	position: absolute;
	display: flex;
	justify-content: center;
	border-radius: 50%;
}
.hour {
	height: 17em;
	width: 17em;
}
.hour:before {
	content: "";
	position: absolute;
	height: 50%;
	width: 5px;
	background-color: #888888;
	border-radius: 6px;
}
.min {
	height: 22.5em;
	width: 22.5em;
}
.min:before {
	content: "";
	height: 50%;
	width: 4px;
	background-color: #888888;
	border-radius: 4px;
}
.sec {
	height: 20em;
	width: 20em;
}
.sec:before {
	content: "";
	height: 50%;
	width: 2px;
	background-color: #f00;
	border-radius: 2px;
}

@media screen and (max-width: 768px) {
	.clock {
		min-height: 20em;
		min-width: 20em;
	}
	.hour {
		height: 12em;
		width: 12em;
	}
	.hour:before {
		height: 50%;
		width: 3px;
	}
	.min {
		height: 15em;
		width: 15em;
	}
	.min:before {
		height: 50%;
		width: 2px;
	}
	.sec {
		height: 13em;
		width: 13em;
	}
	.sec:before {
		height: 50%;
		width: 1px;
	}
}

</style>
